export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';
export const ADD_CHAT_MESSAGE = 'ADD_CHAT_MESSAGE';
export const SET_CHAT_HISTORY = 'SET_CHAT_HISTORY';
export const CHAT_HISTORY_DATA = 'CHAT_HISTORY_DATA';
export const CLEAR_CHAT_HISTORY = 'CLEAR_CHAT_HISTORY';
export const SET_LOADING = 'SET_LOADING';